<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          클래스 목록
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            회원관리(ID주문) → 클래스 목록
          </div>
        </h5>
        <p
          style="
            font-size: 15px;
            margin-top: 10px;
            line-height: 25px;
            color: #004279;
            font-weight: 500;
          "
        >
          - 학생들을 관리할 클래스를 등록할 수 있습니다.
        </p>

        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="(record, i) in props.records" v-bind:key="record.id">
              <td scope="row">{{ record.id }}</td>
              <td
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                {{ record.parent.name }}
              </td>
              <td>
                <Business :biz="record" :ref="'biz' + i" />
              </td>
              <!--td>{{ record.contact }}</td-->
              <td>{{ record.headName }}</td>
              <td>
                <span v-if="record.class_day_0">일</span>
                <span v-if="record.class_day_1">월</span>
                <span v-if="record.class_day_2">화</span>
                <span v-if="record.class_day_3">수</span>
                <span v-if="record.class_day_4">목</span>
                <span v-if="record.class_day_5">금</span>
                <span v-if="record.class_day_6">토</span>
              </td>
              <td>{{ record.class_time }}</td>
              <td>{{ record.class_grade }}</td>
              <td>{{ record.class_type }}</td>
              <td>{{ record.class_level }}</td>
              <td>{{ record.active_cnt }}</td>
              <td>{{ record.all_cnt }}</td>
              <td>
                <button
                  v-if="record.type != 'ROOT'"
                  class="btn btn-danger btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target=".deleteModal"
                  @click="checkDeleteAvailable(record)"
                >
                  삭제
                </button>
              </td>
            </tr>
          </template>
          <template #actions>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".bd-example-modal-lg"
            >
              클래스 등록
            </button>
            <template v-if="this.$root.you.username == 'hiyo2'">
              <button class="btn btn-primary" @click="checkD()">TEST</button>
            </template>
          </template>
        </query-grid>

        <div
          class="modal fade bd-example-modal-lg"
          tabindex="-1"
          id="bizModal"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  클래스 등록
                </h5>
              </div>
              <div class="modal-body">
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">관리자코드</td>
                      <td>자동생성</td>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>사용여부</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select
                              class="custom-select flex_center"
                              id="inputGroupSelect01"
                            >
                              <option selected>선택</option>
                              <option value="1">사용</option>
                              <option value="2">미사용</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>생성</td>
                      <td v-if="isMounted">
                        <tree-btn
                          :tree="this.$refs.bizTree"
                          key="bizclass"
                          style="
                            background: #333;
                            width: 200px;
                            border: 1px solid #222;
                            font-size: 14px;
                            margin: 0;
                          "
                        />
                      </td>
                      <td class="th_bg">생성위치</td>
                      <td>
                        <Business
                          v-for="history in selHistory"
                          :key="history.id"
                          :biz="history"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg" style="height: 50px">소속구분</td>
                      <td>
                        <template v-if="selBiz.type == 'ROOT'"
                          ><button class="btn btn-primary btn-sm">
                            본사
                          </button></template
                        >
                        <template v-if="selBiz.type == 'LOCAL'"
                          ><button class="btn btn-info btn-sm">
                            지사
                          </button></template
                        >
                        <template v-if="selBiz.type == 'ENTERPRISE'"
                          ><button class="btn btn-success btn-sm">
                            학원
                          </button></template
                        >
                        <template v-if="selBiz.type == 'CLASS'"
                          ><button class="btn btn-warning btn-sm">
                            클래스명
                          </button></template
                        >
                      </td>
                      <td class="th_bg">관리구분</td>
                      <td>
                        <template v-if="selBiz.type == 'ROOT'">지사</template>
                        <template v-if="selBiz.type == 'LOCAL'">학원</template>
                        <template v-if="selBiz.type == 'ENTERPRISE'"
                          >클래스</template
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table class="table">
                  <tbody>
                    <tr>
                      <td class="th_bg">
                        <i class="fas fa-check-circle"></i>클래스명
                      </td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.name"
                          placeholder="홍길동"
                        />
                      </td>
                      <!--td class="th_bg"><i class="fas fa-check-circle"></i>클래스명(영문)</td>
                      <td>
                        <input class="hidtype" v-model="changedData.engName" placeholder="홍길동" />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td><input class="hidtype" v-model="changedData.tel"
                          placeholder="02-1544-7000" />
                      </td-->
                      <td class="th_bg">대표강사명</td>
                      <td>
                        <input
                          class="hidtype"
                          v-model="changedData.headName"
                          placeholder="홍길동"
                        />
                      </td>
                    </tr>
                    <!--tr>
                      <td class="th_bg">미국ID</td>
                      <td><input class="hidtype" v-model="changedData.ag_USID" placeholder="미국 아이디" />
                      </td>
                      <td class="th_bg">미국PW</td>
                      <td><input class="hidtype" v-model="changedData.ag_USPW" placeholder="미국 비밀번호" />
                      </td>
                    </tr-->
                    <tr>
                      <td class="th_bg">요일</td>
                      <td>
                        <table>
                          <colgroup>
                            <col style="width: 33%" />
                            <col style="width: 33%" />
                            <col style="width: 33%" />
                          </colgroup>
                          <tr>
                            <td>
                              <li
                                class="form-check form-switch"
                                style="width: 80px"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_0"
                                />
                                <label class="form-check-label">일</label>
                              </li>
                            </td>
                            <td>
                              <li
                                class="form-check form-switch"
                                style="width: 80px"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_1"
                                />
                                <label class="form-check-label">월</label>
                              </li>
                            </td>
                            <td>
                              <div class="form-check form-switch">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_2"
                                />
                                <label class="form-check-label">화</label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <li
                                class="form-check form-switch"
                                style="width: 80px"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_3"
                                />
                                <label class="form-check-label">수</label>
                              </li>
                            </td>
                            <td>
                              <li
                                class="form-check form-switch"
                                style="width: 80px"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_4"
                                />
                                <label class="form-check-label">목</label>
                              </li>
                            </td>
                            <td>
                              <div class="form-check form-switch">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_5"
                                />
                                <label class="form-check-label">금</label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <li
                                class="form-check form-switch"
                                style="width: 80px"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="changedData.class_day_6"
                                />
                                <label class="form-check-label">토</label>
                              </li>
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </table>
                      </td>
                      <td class="th_bg">시간</td>
                      <td>
                        <input
                          type="time"
                          class="hidtype"
                          v-model="changedData.class_time"
                          step="600"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">레벨</td>
                      <td>
                        <select v-model="changedData.class_level"   class="custom-select flex_center" style="width:130px;">
                          <option value="">지정 없음</option>
                          <template v-if="this.selBiz.study_type != 'ALS'">
                            <option value="혼합">혼합</option>
                            <option value="GK">GK</option>
                            <option
                              value="GK_1"
                              v-if="changedData.class_type != 'MyPath'"
                            >
                              GK_1
                            </option>
                            <option value="GR1">GR1</option>
                            <option value="GR2">GR2</option>
                            <option value="GR3">GR3</option>
                            <option value="GR4">GR4</option>
                            <option value="GR5">GR5</option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR6"
                            >
                              GR6
                            </option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR7"
                            >
                              GR7
                            </option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR8"
                            >
                              GR8
                            </option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR9"
                            >
                              GR9
                            </option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR10"
                            >
                              GR10
                            </option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR11"
                            >
                              GR11
                            </option>
                            <option
                              v-if="changedData.class_type != 'ChildU'"
                              value="GR12"
                            >
                              GR12
                            </option>
                          </template>
                          <template v-if="this.selBiz.study_type == 'ALS'">
                            <option value="혼합">혼합</option>
                            <option value="Sprout">Sprout</option>
                            <option value="Blow">Blow</option>
                            <option value="Flag">Flag</option>
                            <option value="Wing">Wing</option>
                            <option value="Dream">Dream</option>
                            <option value="Royal">Royal</option>
                          </template>
                        </select>
                      </td>
                      <td class="th_bg"></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <div class="modal-footer flex_center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="doSend()"
                  >
                    등록
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    닫기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade deleteModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="background: rgba(0, 0, 0, 0.8)"
  >
    <div class="modal-dialog modal-sms modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            기관 삭제 유효성 검사
          </h5>
        </div>
        <div class="modal-body">
          <table class="table">
            <thead>
              <tr scope="row">
                <td>타입</td>
                <td>메시지</td>
                <td>데이터</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(error, i) in deletingErrors" :key="i">
                <tr v-if="error.level != 'WARNING' || showWarn">
                  <td>
                    <template v-if="error.level == 'WARNING'"
                      ><i class="bi bi-exclamation-triangle-fill"></i
                    ></template>
                    <template v-if="error.level == 'ERROR'"
                      ><i class="bi bi-x-circle-fill"></i
                    ></template>
                    <template v-if="error.level == 'SUCCESS'"
                      ><i class="bi bi-check"></i
                    ></template>
                  </td>
                  <td>{{ error.error }}</td>
                  <td>{{ error.data_name }}</td>
                </tr>
              </template>
            </tbody>
          </table>
          오류 {{ errCnt }}개, 경고 {{ warnCnt }}개 (<input
            type="checkbox"
            v-model="showWarn"
          />경고 보기)
          <div class="flex_center">
            <button class="btn btn-info" data-bs-dismiss="modal">취소</button>
            <button
              class="btn btn-danger"
              data-bs-dismiss="modal"
              :disabled="!deletingPermitted"
              @click="commitDelete(selData)"
            >
              삭제
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Tree
    :tree-data="this.$root.businesses"
    :selectable="['ENTERPRISE']"
    :callback="selectedBiz"
    ref="bizTree"
  />
</template>

<style></style>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import treeBtn from "../components/treeBtn";
import QueryGrid from "../components/QueryGrid";

import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    Business,
    treeBtn,
    QueryGrid,
  },
  mounted() {
    console.log(this.$root.you.username);

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.config.columns.splice(1, 1);
    }

    if (this.$root.guiPerm == "ROOT" || this.$root.guiPerm == "LOCAL1") {
      this.config.search_fields.push({
        id: "level_filter",
        name: "레벨",
        type: "switch",
        filter_type: {
          "": "지정 없음",
          혼합: "혼합",
          GK: "GK",
          GK_1: "GK_1",
          GR1: "GR1",
          GR2: "GR2",
          GR3: "GR3",
          GR4: "GR4",
          GR5: "GR5",
          GR6: "GR6",
          GR7: "GR7",
          GR8: "GR8",
          GR9: "GR9",
          GR10: "GR10",
          GR11: "GR11",
          GR12: "GR12",
          Sprout: "Sprout",
          Blow: "Blow",
          Flag: "Flag",
          Wing: "Wing",
          Dream: "Dream",
          Royal: "Royal",
        },
      });
    } else {
      if (this.$root.businesses[0].study_type == "PLS") {
        this.config.search_fields.push({
          id: "level_filter",
          name: "레벨",
          type: "switch",
          filter_type: {
            "": "지정 없음",
            혼합: "혼합",
            GK: "GK",
            GK_1: "GK_1",
            GR1: "GR1",
            GR2: "GR2",
            GR3: "GR3",
            GR4: "GR4",
            GR5: "GR5",
            GR6: "GR6",
            GR7: "GR7",
            GR8: "GR8",
            GR9: "GR9",
            GR10: "GR10",
            GR11: "GR11",
            GR12: "GR12",
          },
        });
      } else {
        this.config.search_fields.push({
          id: "level_filter",
          name: "레벨",
          type: "switch",
          filter_type: {
            "": "지정 없음",
            혼합: "혼합",
            Sprout: "Sprout",
            Blow: "Blow",
            Flag: "Flag",
            Wing: "Wing",
            Dream: "Dream",
            Royal: "Royal",
          },
        });
      }
    }
    this.config.search_fields.push(
      {
        id: "day_filter",
        name: "요일",
        type: "switch",
        filter_type: {
          "": "지정 없음",
          0: "일",
          1: "월",
          2: "화",
          3: "수",
          4: "목",
          5: "금",
          6: "토",
        },
      },
      {
        id: "time_filter",
        name: "시간검색",
        type: "time",
        filter_type: {
          class_time: "시간",
        },
      }
    );
    if (this.$root.guiPerm == "ROOT") {
      this.config.search_fields.push({
        id: "search_del",
        name: "삭제여부",
        type: "switch",
        filter_type: {
          false: "정상",
          true: "삭제",
        },
      });
    }

    this.$nextTick(() => {
      this.isMounted = true;
    });

    this.$refs.qg.search();
  },
  methods: {
    commitDelete(record) {
      axios.delete("/businesses/" + record.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "삭제 실패하였습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "삭제 성공하였습니다. ",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          this.search();
        }
      });
    },
    checkDeleteAvailable(record) {
      this.selData = record;
      this.showDeleteWarns = false;
      this.deletingErrors = [
        {
          level: "ERROR",
          error: "삭제 가능 여부를 조회 중입니다. 잠시만 기다려 주세요.",
          error_code: "FETCHING_DELETE",
          type: "LOADING",
          data_id: "",
          data_name: "시스템",
        },
        {
          level: "ERROR",
          error: "일관성 검사 절차가 들어있어 최장 10초 소요될 수 있습니다.",
          error_code: "FETCHING_DELETE",
          type: "LOADING",
          data_id: "",
          data_name: "시스템",
        },
      ];
      this.deletingPermitted = false;
      axios
        .get("/businesses/" + record.id + "/preCheckBeforeDelete")
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            //에러와 오류로 분리
            this.errCnt = 0;
            this.warnCnt = 0;
            this.deletingErrors = response.data.errors;
            if (response.data.errors.length) {
              response.data.errors.forEach((element) => {
                if (element.level == "ERROR") {
                  this.errCnt++;
                } else {
                  this.warnCnt++;
                }
              });
            }

            if (this.errCnt) {
              this.deletingErrors.push({
                level: "ERROR",
                error: "1개 이상의 오류로 기관을 삭제할 수 없습니다.",
                error_code: "ERROR",
                type: "LOADING",
                data_id: "",
                data_name: "시스템",
              });
              this.deletingPermitted = false;
            } else {
              this.deletingErrors.push({
                level: "SUCCESS",
                error: "기관을 삭제할 수 있습니다.",
                error_code: "SUCCESS",
                type: "LOADING",
                data_id: "",
                data_name: "시스템",
              });
              this.deletingPermitted = true;
            }
          }
        });
    },
    checkD() {
      axios.get("/send_expire_notification_2").then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          console.log(response.data.result);
        }
      });
    },
    downloadErrorsCSV() {},
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz, history) {
      this.selBiz = biz;
      this.selHistory = history;
      if (biz.type == "LOCAL") {
        this.changedData.type = "ENTERPRISE";
      }
      if (biz.type == "ENTERPRISE") {
        this.changedData.type = "CLASS";
      }
      if (biz.type == "ROOT") {
        this.changedData.type = "LOCAL";
      }
    },
    data() {
      return {
        config: {
          name: "클래스리스트",
          req_endpoint: "/businesses/list",
          default_limit: 20,
          search_fields: [
            {
              id: "businesses",
              name: "소속선택",
              type: "business", // business, date, datetime,
            },
            {
              id: "search",
              name: "키워드검색",
              type: "text",
              placeholder: "본부/학원/클래스로 검색",
            },

            {
              id: "prod_filter",
              name: "상품유형",
              type: "switch",
              filter_type: {
                "": "지정 없음",
                혼합: "혼합",
                ChildU: "ChildU",
                MYPATH: "MyPath",
              },
            },
          ],
          columns: [
            {
              id: "id",
              sortable: true,
              name: "번호",
              excel_print: (v) => {
                return v.id;
              },
            },
            {
              id: "name",
              sortable: true,
              name: "클래스명",
              excel_print: (v) => {
                return v.name;
              },
            },
            {
              id: "head_name",
              name: "대표 담임교사",
              sortable: true,
              excel_print: (v) => {
                return v.headName || "";
              },
            },
            {
              id: "class_day",
              name: "요일",
              excel_print: (v) => {
                var mappings = ["일", "월", "화", "수", "목", "금", "토"];
                var res = [];
                for (let i = 0; i < 7; i++) {
                  if (v["class_day_" + i]) {
                    res.push(mappings[i]);
                  }
                }

                return res.join(" ");
              },
            },
            {
              id: "class_time",
              sortable: true,
              name: "시간",
              excel_print: (v) => {
                return v.class_time;
              },
            },
            {
              id: "class_grade",
              sortable: true,
              name: "학년",
              excel_print: (v) => {
                return v.class_grade;
              },
            },
            {
              id: "class_type",
              sortable: true,
              name: "타입",
              excel_print: (v) => {
                return v.class_type;
              },
            },
            {
              id: "class_level",
              sortable: true,
              name: "레벨",
              excel_print: (v) => {
                return v.class_level;
              },
            },
            {
              id: "active_cnt",
              sortable: true,
              name: "정회원",
              excel_print: (v) => {
                return v.active_cnt;
              },
            },
            {
              id: "all_cnt",
              sortable: true,
              name: "전체학생",
              excel_print: (v) => {
                return v.all_cnt;
              },
            },
            {
              id: "status",
              name: "상태",
            },
          ],
          extras_addon: () => {
            return '&filter_type=["CLASS"]';
          },
        },
        records: [],
        selBiz: {
          name: "",
        },
        searchBiz: [],
        selHistory: [],
        searchKeyword: "",
        creating: true,
        selData: {
          id: "",
          parent_id: "",
          name: "",
          createdAt: "",
          endDate: "",
          startDate: "",
          contact: "",
          suspended: "",
          type: "",
          bizcode: "",
          address1: "",
          address2: "",
          tel: "",
          fax: "",
          headName: "",
          intro: "",
          bizNo: "",
          bankCode: "",
          bankName: "",
          bankNum: "",
          agreementType: "",
          agreementPrice: "",
          agreementDate: "",
          local: "",
          engName: "",
          ag_USID: "",
          ag_USPW: "",
          class_day_0: false,
          class_day_1: false,
          class_day_2: false,
          class_day_3: false,
          class_day_4: false,
          class_day_5: false,
          class_day_6: false,
          class_grade: "",
          class_time: "",
          class_level: "",
          class_type: "",
          createAdmin: true,
        },
        changedData: {},
        showDeleteWarns: false,
        deletingErrors: null,
        deletingPermitted: false,
        errCnt: 0,
        warnCnt: 0,
        showWarn: false,
        isMounted: false,
      };
      if (biz.type == "ENTERPRISE") {
        this.changedData.type = "CLASS";
      }
      if (biz.type == "ROOT") {
        this.changedData.type = "LOCAL";
      }
    },
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {
        ...this.selData,
        ...this.changedData,
        parent_id: this.selBiz.id,
        parent_type: this.selBiz.study_type,
      };
      var send = axios({
        method: "post",
        url: "/businesses",
        data: data,
      });
      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.$root.getBusinesses();
          bootstrap.Modal.getInstance(
            document.getElementById("bizModal")
          ).hide();
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
        }
      });
    },
    creatingMode() {
      this.selData = {
        id: "",
        parent_id: "",
        name: "",
        createdAt: "",
        endDate: "",
        startDate: "",
        contact: "",
        suspended: "",
        type: "",
        bizcode: "",
        address1: "",
        address2: "",
        tel: "",
        fax: "",
        headName: "",
        intro: "",
        bizNo: "",
        bankCode: "",
        bankName: "",
        bankNum: "",
        agreementType: "",
        agreementPrice: "",
        agreementDate: "",
        local: "",
        engName: "",
        ag_USID: "",
        ag_USPW: "",
        class_day_0: false,
        class_day_1: false,
        class_day_2: false,
        class_day_3: false,
        class_day_4: false,
        class_day_5: false,
        class_day_6: false,
        class_grade: "",
        class_time: "",
        class_level: "",
        class_type: "",
        createAdmin: true,
      };
      this.changedData = {};
      this.selBiz = {};
      this.creating = true;
      this.$refs.bizTree.reset("");
    },
  },
  data() {
    return {
      config: {
        name: "클래스리스트",
        req_endpoint: "/businesses/list",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "본부/학원/클래스로 검색",
          },

          {
            id: "prod_filter",
            name: "상품유형",
            type: "switch",
            filter_type: {
              "": "지정 없음",
              혼합: "혼합",
              ChildU: "ChildU",
              MYPATH: "MyPath",
            },
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "biz",
            sortable: true,
            name: "학원",
            excel_print: (v) => {
              return v.parent.name;
            },
          },
          {
            id: "name",
            sortable: true,
            name: "클래스명",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "head_name",
            name: "대표 담임교사",
            sortable: true,
            excel_print: (v) => {
              return v.headName || "";
            },
          },
          {
            id: "class_day",
            name: "요일",
            excel_print: (v) => {
              var mappings = ["일", "월", "화", "수", "목", "금", "토"];
              var res = [];
              for (let i = 0; i < 7; i++) {
                if (v["class_day_" + i]) {
                  res.push(mappings[i]);
                }
              }

              return res.join(" ");
            },
          },
          {
            id: "class_time",
            sortable: true,
            name: "시간",
            excel_print: (v) => {
              return v.class_time;
            },
          },
          {
            id: "class_grade",
            sortable: true,
            name: "학년",
            excel_print: (v) => {
              return v.class_grade;
            },
          },
          {
            id: "class_type",
            sortable: true,
            name: "타입",
            excel_print: (v) => {
              return v.class_type;
            },
          },
          {
            id: "class_level",
            sortable: true,
            name: "레벨",
            excel_print: (v) => {
              return v.class_level;
            },
          },
          {
            id: "active_cnt",
            sortable: true,
            name: "정회원",
            excel_print: (v) => {
              return v.active_cnt;
            },
          },
          {
            id: "all_cnt",
            sortable: true,
            name: "전체학생",
            excel_print: (v) => {
              return v.all_cnt;
            },
          },
          {
            id: "status",
            name: "상태",
          },
        ],
        extras_addon: () => {
          return '&filter_type=["CLASS"]';
        },
      },
      records: [],
      selBiz: {
        name: "",
      },
      searchBiz: [],
      selHistory: [],
      searchKeyword: "",
      creating: true,
      selData: {
        id: "",
        parent_id: "",
        name: "",
        createdAt: "",
        endDate: "",
        startDate: "",
        contact: "",
        suspended: "",
        type: "",
        bizcode: "",
        address1: "",
        address2: "",
        tel: "",
        fax: "",
        headName: "",
        intro: "",
        bizNo: "",
        bankCode: "",
        bankName: "",
        bankNum: "",
        agreementType: "",
        agreementPrice: "",
        agreementDate: "",
        local: "",
        engName: "",
        ag_USID: "",
        ag_USPW: "",
        class_day_0: false,
        class_day_1: false,
        class_day_2: false,
        class_day_3: false,
        class_day_4: false,
        class_day_5: false,
        class_day_6: false,
        class_grade: "",
        class_time: "",
        class_level: "",
        class_type: "",
        createAdmin: true,
      },
      changedData: {},
      showDeleteWarns: false,
      deletingErrors: null,
      deletingPermitted: false,
      errCnt: 0,
      warnCnt: 0,
      showWarn: false,
      isMounted: false,
    };
  },
};
</script>
